$(document).on("click", ".open-video-modal", function(e) {
  e.preventDefault();

  const $elem = $(this);
  const title = $elem.attr("title");
  const html = $elem.data("info");

  $modal = $(".video-modal");
  $modal.find(".modal-body").html($elem.data("iframe"));
  // $modal.find(".info-modal-title").html(title);
  // $modal.find(".info-modal-content").html(html);
  $modal.modal().show();
});
